import React from 'react';
import { TypographyH3 } from '@/Components/shadcn';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import { useAssessmentsOverviewContext } from '../../Contexts/AssessmentsOverviewContext';
import UIStrings from '@/Utils/UIStrings';
import CreateRecruitmentButton from '../CreateRecruitmentButton';

const EmptyAssessmentsOverview = (): React.JSX.Element => {
    const { status } = useAssessmentsOverviewContext();

    return (
        <div className="flex h-full flex-col items-center justify-center gap-4 px-4">
            <TypographyH3 className="text-foreground text-center text-lg font-normal whitespace-pre-line">
                {status === AssessmentStatuses.Closed
                    ? UIStrings.ThereAreNoClosedRecruitments
                    : UIStrings.ThereAreNoActiveRecruitments}
            </TypographyH3>
            {status !== AssessmentStatuses.Closed && <CreateRecruitmentButton />}
        </div>
    );
};

export default EmptyAssessmentsOverview;
